import axios, { AxiosError } from 'axios';
import { useQuery } from '@tanstack/react-query';

type UseGetGroupedAnalyzersWithSwitchOptions = {
    analyzerId: number;
  };
  
  export const getGroupedAnalyzersWithSwitch = async ({
    analyzerId,
  }: UseGetGroupedAnalyzersWithSwitchOptions) => {
    const endpoint = `/api/analyzers/${analyzerId}/connection`;
  
    try {
      const response = await axios.get(endpoint);
      return response.data;
    } catch (error) {
      const axiosError = error as AxiosError;
      if (axiosError.response?.status === 404) {
        return []; // Return an empty array if the status code is 404
      }
      throw error; // Re-throw the error if it's something else
    }
  };
  

  
  
  export const useGetGroupedAnalyzersWithSwitch = (
    options: UseGetGroupedAnalyzersWithSwitchOptions
  ) => {
    return useQuery(['groupedAnalyzersWithSwitch', options.analyzerId], () =>
      getGroupedAnalyzersWithSwitch(options)
    );
  };
  